// packages/data/src/default-registry.js
import { createRegistry } from "./registry";
var default_registry_default = createRegistry();
export {
  default_registry_default as default
};
//# sourceMappingURL=default-registry.js.map
